import {
    Button,
    Card,
    CardBody, CardFooter,
    CardHeader, Center,
    Container, Flex,
    FormControl, Text,
    FormLabel, Heading,
    Input,
} from "@chakra-ui/react";
import {FormEvent, useEffect, useState} from "react";
import {useLogin} from "../../../utils/hooks/useLogin";
import {useAuthContext} from "../../../utils/hooks/useAuthContext";
import {TalesSpinner} from "../../atoms";
import {useNavigate} from "react-router";
import {ROUTES} from "../../../utils/constants";
import {Helmet} from "react-helmet";

export default function Login () {
    const [email, setEmail] = useState('');
    const [pw, setPw] = useState('');
    const [formError, setFormError] = useState('');
    const {login, isPending, error, resetError} = useLogin();
    const {user, authIsReady} = useAuthContext();
    const navigate = useNavigate();

    useEffect(() => {
        if(user) {
            navigate(ROUTES.ADMIN_DASHBOARD);
        }
    }, [user]);

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        setFormError('');
        resetError();
        if(!email || email === '' || !pw || pw === '') {
            setFormError('Inserire email e password');
            return;
        }
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))) {
            setFormError('Email non valida');
            return;
        }

        login(email, pw);
    }

    return (
            <Flex width={"100vw"} height={"100vh"} alignContent={"center"} justifyContent={"center"}>
                <Helmet>
                    <meta name="robots" content="noindex"/>
                </Helmet>
                <Center>
                    { authIsReady || user
                            ? <Container w='4xl' m='auto'>
                                <Card p='50px'>
                                    <CardHeader>
                                        <Heading>Admin Tales</Heading>
                                    </CardHeader>
                                    <CardBody>
                                        <FormControl isRequired marginBottom='20px'>
                                            <FormLabel>Email</FormLabel>
                                            <Input type='email'
                                                   onChange={(e) => setEmail(e.target.value)}
                                                   value={email}
                                            />
                                        </FormControl>
                                        <FormControl isRequired>
                                            <FormLabel>Password</FormLabel>
                                            <Input type='password'
                                                   onChange={(e) => setPw(e.target.value)}
                                                   value={pw}
                                            />
                                        </FormControl>
                                    </CardBody>
                                    <CardFooter>
                                        {!isPending && <Button onClick={handleSubmit}>Login</Button>}
                                        {isPending &&  <TalesSpinner />}
                                    </CardFooter>
                                    {(error || formError) && <Text variant='formError'>{error}{formError}</Text>}
                                </Card>
                            </Container>
                            : <TalesSpinner />
                    }
                </Center>
            </Flex>
        )


}